module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('GmapMap', {
    ref: "gmap",
    staticStyle: {
      "width": "100%",
      "height": "525px !important"
    },
    attrs: {
      "center": {
        lat: 20.5937,
        lng: 78.9629
      },
      "zoom": 16,
      "map-type-id": "roadmap",
      "options": {
        mapTypeControl: false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6efb5f6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/gmapLocation/kmlView.vue
// module id = 2347
// module chunks = 1